import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteHook } from '@shared/hooks';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api/rest/users';
import { ColorsEnum, Icon, Table, TableCellType, Text } from '@shared/widgets';
import LockIcon from '@assets/icons/lock.svg';

interface IUserListViewProps {
  users: UserWithPaymentInfo[];
}

export const UserListView = (props: IUserListViewProps) => {
  const { navigate } = useRouteHook();

  const { t } = useTranslation('userManagement');

  const columns = useMemo(() => [t('user.columns.fullName'), t('user.columns.position'), t('user.columns.accounts'), t('user.columns.cards')], [t]);
  return (
    <Table
      isScrollable
      columns={columns}
      items={props.users.map((user) => {
        return [
          {
            type: TableCellType.Custom,
            value: (
              <div className='flex shrink-0 items-center'>
                <div className='relative mr-3 flex h-8 w-8 flex-none select-none items-center justify-center overflow-hidden rounded-full text-base'>
                  <div className='relative z-[1] flex h-full w-full items-center justify-center rounded bg-primary'>
                    <Text weight='medium' size='xl' color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)}>
                      {user.firstName?.split('')[0]}
                    </Text>
                  </div>
                  {user.locked && (
                    <div className='absolute left-0 top-0 z-[3] flex h-full w-full items-center justify-center rounded bg-dark-wet-asphalt text-center'>
                      <Icon icon={<LockIcon width='24' height='24' />} color='red' />
                    </div>
                  )}
                </div>
                <div className='flex-1 px-0 py-0.5'>
                  <Text className='overflow-hidden text-ellipsis' size='sm'>
                    {user.firstName} {user.lastName}
                  </Text>
                </div>
              </div>
            ),
          },
          { type: TableCellType.Text, value: user.position },
          { type: TableCellType.Text, value: user.accounts.length },
          { type: TableCellType.Text, value: user.cards.length },
        ];
      })}
      onClick={(rowIndex) => navigate(RoutePaths.user.onNavigate(props.users[rowIndex].id))}
    />
  );
};
